module.exports = __webpack_public_path__ + "img/logo_white.c9ca5e34.svg";